import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupShareDialogComponent,GroupShareDialogClose } from 'src/app/components/dialogs/admin/groups-share-dialog/groups-share-dialog.component';
import { GroupShareDialogModeEnum } from 'src/app/models/services/admin/groups-share/GroupShareDialogModeEnum.enum'
import { GroupShareDialogCloseEnum } from 'src/app/models/services/admin/groups-share/GroupShareDialogCloseEnum.enum'
import { GroupShare } from 'src/app/models/services/admin/groups-share/groupShare';

interface OpenPayload {
  mode: GroupShareDialogModeEnum;
  groupShare?: GroupShare | null;
}

@Injectable({ providedIn: 'root' })
export class GroupShareDialogService {
  constructor(private modalService: NgbModal) {}
  open(payload: OpenPayload): Promise<GroupShareDialogClose> {
    const ref = this.modalService.open(
      GroupShareDialogComponent,
      {
        size: 'xl',
        centered: true,
        windowClass: 'group-share-modal'
      }
    );
    const cmp = ref.componentInstance as GroupShareDialogComponent;
    cmp.mode = payload.mode;
    cmp.groupShare = payload.groupShare ?? null;
    return new Promise<GroupShareDialogClose>((resolve) => {
      cmp.accept = (res: GroupShareDialogClose) => {
        resolve(res);
        ref.close('accept');
      };
      cmp.dismiss = () => {
        resolve({ action: GroupShareDialogCloseEnum.Cancel });
        ref.dismiss('cancel');
      };
    });
  }

  createGroup() {
    return this.open({ mode: GroupShareDialogModeEnum.CreateGroupShare });
  }

  editGroup(groupShare: GroupShare) {
    return this.open({ mode: GroupShareDialogModeEnum.EditGroupShare, groupShare });
  }

  public show = (acceptCallback: (data: any) => void, rejectCallback?: () => void, groupShareParameters?: any): void => {
    const mode: GroupShareDialogModeEnum = groupShareParameters ? GroupShareDialogModeEnum.EditGroupShare : GroupShareDialogModeEnum.CreateGroupShare;
    this.open({ mode, groupShare: groupShareParameters ?? null })
      .then((res) => {
        if (res.action === GroupShareDialogCloseEnum.CreateGroupShare) acceptCallback(res.data);
        else if (res.action === GroupShareDialogCloseEnum.EditGroupShare) acceptCallback({ id: res.id, ...res.data });
        else rejectCallback?.();
      })
      .catch(() => rejectCallback?.());
  };
}
